export default __webpack_public_path__ + "f384c6ff1f0ab91367b6284bddd0ccad.png";